import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import RadioGroupSet from '@shared/components/inputs/Radio/RadioGroupSet';
import type { InstallationMethod } from '@t/checkout.types';

import type { MethodSelectorProps } from './InstallationStep.types';

const buildOptions = (hasTechnician: boolean, hasSelf: boolean): { value: InstallationMethod; label: string }[] => {
  const options: { value: InstallationMethod; label: string }[] = [];
  if (hasTechnician) options.push({ value: 'TECHNICIAN', label: 'Technician' });
  if (hasSelf) options.push({ value: 'SELF', label: 'Self-Installation' });
  return options;
};

export const MethodSelector = ({ technicianOptions, value, onChange }: MethodSelectorProps) => {
  const hasTechnician = technicianOptions.some((o) => o.installationMethod === 'TECHNICIAN');
  const hasSelf = technicianOptions.some((o) => o.installationMethod === 'SELF');
  const options = buildOptions(hasTechnician, hasSelf);

  if (options.length === 0) return null;

  return (
    <Stack gap="10px">
      <Typography variant="label.field" sx={{ lineHeight: '150%' }}>
        Select Installation Method
      </Typography>

      <RadioGroupSet value={value} onChange={onChange} options={options} gap="10px" />
    </Stack>
  );
};
